// components
import {
  styled,
  Box,
  Button,
  ButtonProps,
  BoxProps,
  alpha
} from '@mui/material';

// constants
import { FILTER_POPOVER_WIDTH } from './FilterPopper.consts';
import { StyledBoxFlexCenter } from 'components/shared/Box/Box.styles';

export const StyledPopoverMainWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'enableSettings'
})<BoxProps & { enableSettings?: boolean }>(({ enableSettings }) => ({
  display: 'flex',
  flexDirection: enableSettings ? 'row' : 'column',
  position: 'relative'
}));

export const StyledPopoverContainerBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  minWidth: FILTER_POPOVER_WIDTH
}));

export const StyledMoreFiltersButton = styled(Button)<ButtonProps>(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  })
);

export const StyledSettingsSection = styled(Box)<BoxProps>(({ theme }) => ({
  padding: theme.spacing(3.75, 4),
  backgroundColor: alpha(theme.palette.background.default, 0.5),
  borderRight: `1px solid ${theme.palette.divider}`,
  minWidth: '300px',
  boxSizing: 'border-box',
  boxShadow: `inset -12px 0 16px -16px ${theme.vars.palette.secondary.fixedDim}`,
  maxHeight: '450px',
  overflow: 'auto'
}));

export const StyledPopoverHeader = styled(Box)<BoxProps>(({ theme }) => ({
  padding: theme.spacing(4, 4, 0, 4)
}));

export const StyledPopoverContent = styled(Box)<BoxProps>(({ theme }) => ({
  minWidth: 'inherit',
  padding: theme.spacing(0, 4),
  margin: theme.spacing(1, 0)
}));

export const StyledPopoverFooter = styled(Box)<BoxProps>(({ theme }) => ({
  backgroundColor: alpha(theme.palette.background.default, 0.5),
  padding: theme.spacing(4),
  borderTop: `1px solid ${theme.palette.divider}`,
  flexGrow: 1
}));

export const StyledSettingsSectionContent = styled(
  StyledBoxFlexCenter
)<BoxProps>(({ theme }) => ({
  marginBottom: theme.spacing(2)
}));
